import styled from 'styled-components';

export default styled.h4`
	font-family: ${({ theme }) => theme.fonts.slabBold};
	font-size: ${({ theme }) => theme.fontSizes.xs};
	color: ${({ textColor }) => textColor ? textColor : ({ theme }) => theme.colors.AGCOBlack};
`;
